import { useTheme } from "next-themes";
import { Toaster as Sonner } from "sonner";

const Toaster = ({ ...props }) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-river-bed group-[.toaster]:text-white group-[.toaster]:border-comet group-[.toaster]:rounded-md group-[.toaster]:shadow-lg",
          title: "",
          description: "group-[.toast]:text-light-gray-300",
          actionButton: "group-[.toast]:white group-[.toast]:dark-gray",
          cancelButton: "group-[.toast]:white group-[.toast]:dark-gray",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
